"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var SocialIcon_1 = __importDefault(require("./SocialIcon"));
var RegionSelector_1 = __importDefault(require("./RegionSelector"));
var Box_1 = __importDefault(require("../Box"));
var components_1 = require("./components");
var CopyRight_1 = __importDefault(require("./CopyRight"));
function DesktopFooter(props) {
    var _a = props || {}, regions = _a.regions, footerRegion = _a.footerRegion, navLinks = _a.navLinks, extraLinks = _a.extraLinks, socialLinks = _a.socialLinks, copyright = _a.copyright;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TopLinkContainer, null, navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (navLink, index) {
            var _a;
            return (react_1.default.createElement(LinkContainer, { key: index, flex: 1 }, (_a = navLink === null || navLink === void 0 ? void 0 : navLink.links) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (react_1.default.createElement(components_1.NavLink, { key: item.text, href: item.url }, item.text)); })));
        })),
        react_1.default.createElement(SocialIcon_1.default, { socialLinks: socialLinks }),
        react_1.default.createElement(components_1.Divider, null),
        react_1.default.createElement(BottomContent, null,
            react_1.default.createElement(CopyRight_1.default, { mr: '60px', copyright: copyright }),
            react_1.default.createElement(Box_1.default, { display: 'flex', flex: '1', justifyContent: 'space-between', alignItems: 'center' },
                react_1.default.createElement(BottomLinkContainer, null, extraLinks === null || extraLinks === void 0 ? void 0 : extraLinks.map(function (link) { return (react_1.default.createElement(components_1.BottomNavLink, { key: link.text, href: link.url }, link.text)); })),
                react_1.default.createElement(RegionSelector_1.default, { footerRegion: footerRegion, regions: regions })))));
}
var TopLinkContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flexWrap: 'wrap',
            padding: '42px 0px 0px 150px',
            paddingTop: '42px',
            paddingRight: '0px',
            paddingBottom: '0px',
            paddingLeft: '36px',
            flexDirection: 'row',
            gap: '32px'
        },
        _b[theme.mediaQueries.lg] = {
            paddingLeft: '150px',
        },
        _b);
});
var LinkContainer = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
});
var BottomLinkContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'none'
        },
        _b[theme.mediaQueries.md] = {
            display: 'flex',
            gap: '30px',
            flexWrap: 'wrap'
        },
        _b);
});
var BottomContent = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            paddingTop: '15px',
            paddingRight: '55px',
            paddingLeft: '36px',
            paddingBottom: '65px'
        },
        _b[theme.mediaQueries.lg] = {
            paddingLeft: '150px',
            paddingRight: '169px',
        },
        _b);
});
exports.default = DesktopFooter;
